/* ============================================================
   NATURECAN PDP — interactions (ported from design app.js)
   Shopify owns the cart, variant selection and pricing, so the
   original fake-cart / fake-price / bottle-renderer code is
   intentionally omitted. This file only powers the bespoke UI:
   read-more, in-buy-box accordions, horizontal rails, the
   ingredient selector, FAQ accordion and review filter.
   Idempotent + re-runs on Shopify section render events so it
   keeps working inside the theme editor.
   ============================================================ */
(function () {
  "use strict";

  function initReadMore(root) {
    root.querySelectorAll("[data-readmore]").forEach(function (rm) {
      var btn = rm.querySelector(".readmore__btn");
      if (!btn || btn.dataset.bound) return;
      btn.dataset.bound = "1";
      var labelOpen = btn.dataset.labelOpen || "Read less";
      var labelClosed = btn.textContent.trim() || "Read more";
      btn.addEventListener("click", function () {
        var open = rm.classList.toggle("is-open");
        btn.textContent = open ? labelOpen : labelClosed;
      });
    });
  }

  function initBBAcc(root) {
    root.querySelectorAll(".bb-acc__q").forEach(function (q) {
      if (q.dataset.bound) return;
      q.dataset.bound = "1";
      q.addEventListener("click", function () {
        var item = q.closest(".bb-acc__item");
        var a = item.querySelector(".bb-acc__a");
        if (item.classList.contains("is-open")) {
          item.classList.remove("is-open");
          a.style.maxHeight = 0;
        } else {
          item.classList.add("is-open");
          a.style.maxHeight = a.scrollHeight + "px";
        }
      });
    });
  }

  function buildFaqFromText(root) {
    root.querySelectorAll("[data-faq-raw]").forEach(function (src) {
      if (src.dataset.built) return;
      src.dataset.built = "1";
      var target = src.closest(".wrap") && src.closest(".wrap").querySelector("[data-faq-target]");
      if (!target) return;
      var raw = src.textContent || "";
      var lines = raw.split("\n");
      var items = [];
      var current = null;
      lines.forEach(function (line) {
        line = line.trim();
        if (line.indexOf("## ") === 0) {
          if (current) items.push(current);
          current = { q: line.replace(/^##\s+/, ""), a: [] };
        } else if (current && line !== "") {
          current.a.push(line);
        }
      });
      if (current) items.push(current);
      var html = items.map(function (item) {
        return '<div class="faq__item">' +
          '<button class="faq__q" type="button">' + item.q + ' <span class="pm"></span></button>' +
          '<div class="faq__a"><p>' + item.a.join(" ") + '</p></div>' +
          '</div>';
      }).join("");
      target.innerHTML = html;
      initFAQ(target);
    });
  }

  function initFAQ(root) {
    root.querySelectorAll(".faq__q").forEach(function (q) {
      if (q.dataset.bound) return;
      q.dataset.bound = "1";
      q.addEventListener("click", function () {
        var item = q.closest(".faq__item");
        var a = item.querySelector(".faq__a");
        if (item.classList.contains("is-open")) {
          item.classList.remove("is-open");
          a.style.maxHeight = 0;
        } else {
          item.classList.add("is-open");
          a.style.maxHeight = a.scrollHeight + "px";
        }
      });
    });
  }

  function initReviewFilter(root) {
    root.querySelectorAll(".rev-filter").forEach(function (filter) {
      if (filter.dataset.bound) return;
      filter.dataset.bound = "1";
      var scope = filter.closest(".reviews") || root;
      filter.querySelectorAll(".chip").forEach(function (chip) {
        chip.addEventListener("click", function () {
          filter.querySelectorAll(".chip").forEach(function (c) { c.classList.remove("is-active"); });
          chip.classList.add("is-active");
          var f = chip.dataset.stars;
          scope.querySelectorAll(".rev-card").forEach(function (card) {
            card.style.display = (f === "all" || card.dataset.stars === f) ? "" : "none";
          });
        });
      });
    });
  }

  function initRails(root) {
    root.querySelectorAll("[data-rail]").forEach(function (group) {
      if (group.dataset.bound) return;
      group.dataset.bound = "1";
      var rail = group.querySelector(".yml-rail, .ugc-rail, .ing-cards__rail, .cap__rail-inner");
      var prev = group.querySelector("[data-rail-prev]");
      var next = group.querySelector("[data-rail-next]");
      if (!rail) return;
      var step = function () { return Math.min(rail.clientWidth * 0.8, 520); };
      if (prev) prev.addEventListener("click", function () { rail.scrollBy({ left: -step(), behavior: "smooth" }); });
      if (next) next.addEventListener("click", function () { rail.scrollBy({ left: step(), behavior: "smooth" }); });
    });
  }

  function initIngredientSelector(root) {
    // Handle both .ingx (legacy) and .ingsel (new Love Wellness style)
    [".ingx", ".ingsel"].forEach(function(sel) {
      root.querySelectorAll(sel).forEach(function (container) {
        if (container.dataset.bound) return;
        container.dataset.bound = "1";
        var items = container.querySelectorAll(".ingx__item, .ingsel__item");
        var imgs = container.querySelectorAll(".ingx__media img, .ingsel__img");
        function activate(item) {
          var key = item.dataset.ing;
          items.forEach(function (i) {
            i.classList.toggle("is-active", i === item);
            i.setAttribute("aria-expanded", i === item ? "true" : "false");
          });
          imgs.forEach(function (im) {
            im.classList.toggle("is-active", im.dataset.ingImg === key);
          });
        }
        items.forEach(function (item) {
          item.addEventListener("click", function () { activate(item); });
          item.addEventListener("keydown", function (e) {
            if (e.key === "Enter" || e.key === " ") { e.preventDefault(); activate(item); }
          });
        });
      });
    });
  }

  function initClinRotator(root) {
    root.querySelectorAll("[data-clin-rotator]").forEach(function (rot) {
      if (rot.dataset.bound) return;
      rot.dataset.bound = "1";
      var items = rot.querySelectorAll(".clin-bar");
      if (items.length < 2) return;
      var i = 0;
      setInterval(function () {
        items[i].classList.remove("is-active");
        i = (i + 1) % items.length;
        items[i].classList.add("is-active");
      }, 4500);
    });
  }

  function initCrossSellAdd(root) {
    root.querySelectorAll("[data-nc-add]").forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = "1";
      var adding = false;

      btn.addEventListener("click", function () {
        if (adding || btn.disabled) return;
        var variantId = btn.getAttribute("data-variant-id");
        var discountCode = btn.getAttribute("data-discount");
        if (!variantId) return;

        adding = true;
        btn.disabled = true;
        var original = btn.textContent;

        var sectionIds = [];
        document.querySelectorAll("cart-items-component[data-section-id]").forEach(function (el) {
          sectionIds.push(el.dataset.sectionId);
        });

        var formData = new FormData();
        formData.append("id", variantId);
        formData.append("quantity", "1");
        if (sectionIds.length) formData.append("sections", sectionIds.join(","));

        var addUrl = (window.Theme && Theme.routes && Theme.routes.cart_add_url) || "/cart/add.js";

        fetch(addUrl, { method: "POST", body: formData })
          .then(function (r) {
            if (!r.ok) throw new Error("add failed: " + r.status);
            return r.json();
          })
          .then(function (added) {
            if (added && added.status) throw new Error(added.description || "add failed");

            // Show success immediately — do not wait for background work
            btn.classList.add("is-added");
            btn.textContent = "Added ✓";
            setTimeout(function () {
              btn.classList.remove("is-added");
              btn.textContent = original;
              btn.disabled = false;
              adding = false;
            }, 1500);

            // Apply discount in background — non-blocking, never delays the UI
            if (discountCode) {
              fetch("/discount/" + encodeURIComponent(discountCode)).catch(function () {});
            }

            // Dispatch the same event Horizon's cart drawer listens for
            // (mirrors sections/tabbed-products.liquid — the confirmed-working implementation).
            var cartStatePromise = Promise.resolve({
              cart: null,
              detail: { sections: added.sections || {} }
            });

            import("@shopify/events").then(function (m) {
              var cartEvent = new m.CartLinesUpdateEvent({ action: "add", promise: cartStatePromise });
              document.dispatchEvent(cartEvent);
            });
          })
          .catch(function () {
            btn.textContent = original;
            btn.disabled = false;
            adding = false;
          });
      });
    });
  }

  function ugcEmbedMarkup(tile) {
    var src = tile.getAttribute("data-video-src");
    var url = tile.getAttribute("data-video-url");
    var ig = tile.getAttribute("data-instagram");

    if (src) {
      return '<video src="' + src + '" controls autoplay playsinline></video>';
    }
    if (url) {
      var yt = url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/))([\w-]{11})/);
      if (yt) return '<iframe src="https://www.youtube.com/embed/' + yt[1] + '?autoplay=1" allow="autoplay; encrypted-media" allowfullscreen></iframe>';
      var vm = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
      if (vm) return '<iframe src="https://player.vimeo.com/video/' + vm[1] + '?autoplay=1" allow="autoplay; fullscreen" allowfullscreen></iframe>';
      return '<video src="' + url + '" controls autoplay playsinline></video>';
    }
    if (ig) {
      var clean = ig.split("?")[0].replace(/\/$/, "");
      return '<iframe src="' + clean + '/embed" allowtransparency="true" frameborder="0" scrolling="no"></iframe>';
    }
    return "";
  }

  function openUgcDialog(tile) {
    var markup = ugcEmbedMarkup(tile);
    if (!markup) return;
    var dialog = document.createElement("div");
    dialog.className = "nc-pdp nc-ugc-dialog";
    dialog.innerHTML =
      '<div class="nc-ugc-dialog__inner">' +
      '<button class="nc-ugc-dialog__close" type="button" aria-label="Close">&times;</button>' +
      markup +
      "</div>";
    function close() { dialog.remove(); document.removeEventListener("keydown", onKey); }
    function onKey(e) { if (e.key === "Escape") close(); }
    dialog.addEventListener("click", function (e) {
      if (e.target === dialog || e.target.closest(".nc-ugc-dialog__close")) close();
    });
    document.addEventListener("keydown", onKey);
    document.body.appendChild(dialog);
  }

  function initUgc(root) {
    root.querySelectorAll(".ugc-tile").forEach(function (tile) {
      if (tile.dataset.bound) return;
      if (!tile.getAttribute("data-video-src") && !tile.getAttribute("data-video-url") && !tile.getAttribute("data-instagram")) return;
      tile.dataset.bound = "1";
      tile.addEventListener("click", function () { openUgcDialog(tile); });
      tile.addEventListener("keydown", function (e) {
        if (e.key === "Enter" || e.key === " ") { e.preventDefault(); openUgcDialog(tile); }
      });
    });
  }

  function openPdfDialog(url) {
    if (!url) return;
    var dialog = document.createElement("div");
    dialog.className = "nc-pdp nc-pdf-dialog";
    dialog.innerHTML =
      '<div class="nc-pdf-dialog__inner">' +
      '<button class="nc-pdf-dialog__close" type="button" aria-label="Close">&times;</button>' +
      '<iframe src="' + url + '" title="Certificate of Analysis"></iframe>' +
      "</div>";
    function close() { dialog.remove(); document.removeEventListener("keydown", onKey); }
    function onKey(e) { if (e.key === "Escape") close(); }
    dialog.addEventListener("click", function (e) {
      if (e.target === dialog || e.target.closest(".nc-pdf-dialog__close")) close();
    });
    document.addEventListener("keydown", onKey);
    document.body.appendChild(dialog);
  }

  function initCoaViewer(root) {
    root.querySelectorAll("[data-coa-link]").forEach(function (link) {
      if (link.dataset.bound) return;
      link.dataset.bound = "1";
      link.addEventListener("click", function (e) {
        e.preventDefault();
        openPdfDialog(link.getAttribute("data-pdf-url"));
      });
    });
  }

  function init(root) {
    root = root || document;
    initCrossSellAdd(root);
    initUgc(root);
    initCoaViewer(root);
    buildFaqFromText(root);
    initReadMore(root);
    initBBAcc(root);
    initFAQ(root);
    initReviewFilter(root);
    initRails(root);
    initIngredientSelector(root);
    initClinRotator(root);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { init(document); });
  } else {
    init(document);
  }

  // Re-bind when a section is re-rendered in the theme editor.
  document.addEventListener("shopify:section:load", function (e) { init(e.target); });
  document.addEventListener("shopify:block:select", function (e) { init(e.target); });

  window.NaturecanPDP = { init: init };
})();


